// components/navbar/DesktopNavbar.js
import React, { useState, useRef } from 'react';
import NavLogo from './NavLogo';
import NavLinks from './NavLinks';
import ThemeToggle from './ThemeToggle';
import NavSearch from './NavSearch';
import NavAuth from './NavAuth';

const DesktopNavbar = () => {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const navbarRef = useRef(null);

  // Track search expanded state from NavSearch
  const handleSearchExpandedChange = (expanded) => {
    setIsSearchExpanded(expanded);
  };

  return (
    <nav className={`navbar desktop-navbar ${isSearchExpanded ? 'search-expanded' : ''}`} ref={navbarRef}>
      <div className="navbar-container">
        {/* Left section - Logo */}
        <NavLogo />
        
        {/* Center section - Navigation Links */}
        <div className="desktop-nav-links">
          <NavLinks isMobile={false} />
        </div>

        {/* Right section - Search, Theme, Auth */}
        <div className="navbar-right">
          <div className="theme-toggle-wrapper">
            <ThemeToggle />
          </div>
          
          <NavSearch onExpandedChange={handleSearchExpandedChange} />
          
          <NavAuth isMobile={false} />
        </div>
      </div>
    </nav>
  );
};

export default DesktopNavbar;